/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Word_Forward_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shift Word Down" |
*
* @param {Shift_Word_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_word_forward_aria_label = /** @type {((inputs?: Shift_Word_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Word_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler le Mot en Bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort nach unten verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta parola verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть слово вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar palabra hacia abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下移动单词")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を下へシフト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को नीचे ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque a palavra para baixo")
	return /** @type {LocalizedString} */ ("Shift Word Down")
});